import { render, staticRenderFns } from "./ArtistBankInformation.vue?vue&type=template&id=5ccb61c8&scoped=true"
import script from "./ArtistBankInformation.vue?vue&type=script&lang=js"
export * from "./ArtistBankInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccb61c8",
  null
  
)

export default component.exports